import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { breakpointCodes } from 'rp-mq-breakpoints';
import DataTable from './GridDataTable';
import tableConfig from '../config/statisticsVendorsTable';
import {
    initialTableUpdate
} from '../helpers/dispatchProps';
import VendorsHeader from '../components/DataTable/StatisticsVendorsHeader';
import TableBody from '../components/DataTable/ExpandableRowsBody';
import StatisticsLots from '../components/DataTable/StatisticsLots';
import { expandRow } from '../actions/expandableRow';

const stateKey = 'statisticsVendors';
const { EXTRA_NARROW, NARROW } = breakpointCodes;

/**
 * Container for statistics vendors view
 */
class StatisticsVendors extends Component {
    static colSpanGetter = (breakpoint) => {
        switch (breakpoint) {
            case EXTRA_NARROW:
                return 4;
            case NARROW:
                return 6;
            default:
                return 10;
        }
    };

    getTableProps() {
        return {
            headerComponent: VendorsHeader,
            bodyComponent: TableBody,
            bodyProps: {
                expansionComponent: ({ data }) => (
                    <StatisticsLots
                        className="statsVendors__lots"
                        cellClassName="statsVendors__lotsCell"
                        listClassName="statsVendors__lotsList"
                        entities={data.entities}
                        colSpanGetter={StatisticsVendors.colSpanGetter}
                    />
                ),
                expandedRow: this.props.expandedRow,
                onRowExpand: this.props.onRowExpand,
                primaryColumn: 'uid'
            }
        };
    }

    render() {
        return (
            <div className="statsVendors">
                <DataTable
                    config={tableConfig}
                    stateKey={stateKey}
                    errorMessage="No vendors in our records for this sale"
                    colSpanGetter={StatisticsVendors.colSpanGetter}
                    onMount={initialTableUpdate()}
                    tableProps={this.getTableProps()}
                />
            </div>
        );
    }
}

StatisticsVendors.propTypes = {
    /**
     * Primary column value of expanded row
     * State prop
     */
    expandedRow: PropTypes.any,
    /**
     * Expandable row onRowExpand event handler
     * Dispatch prop
     */
    onRowExpand: PropTypes.func,
};


/**
 * Create component properties based on app state
 *
 * @param {{}} state App state
 * @returns {{}} Properties
 */
function mapStateToProps(state) {
    const { expandedRow } = state[stateKey].expandableRow;
    return {
        expandedRow,
    };
}

/**
 * Create component callable properties
 *
 * @returns {{}} Properties
 */
function mapDispatchToProps(dispatch) {
    return {
        onRowExpand(rowIndex) {
            dispatch(expandRow(stateKey, rowIndex));
        }
    };
}


export default connect(mapStateToProps, mapDispatchToProps)(StatisticsVendors);



// WEBPACK FOOTER //
// ./src/js/containers/StatisticsVendors.js